module.exports = __webpack_public_path__ + "static/media/app7.9ce8aa20.png";